import { Button, ScrollView, Tooltip } from 'devextreme-react';
import Toolbar, { Item as ItemToolBar } from 'devextreme-react/toolbar';
import { formatMessage } from 'devextreme/localization';
import { useAppSelector } from '../../../contexts/hooks';
import { useScreenSize } from '../../../utils/media-query';
import moment from 'moment';
import { viewPatient } from '../../../images/icons';

export const InfoPanelPatient = ({ PatientData, handleClickViewPatient }) => {
  const ColumnsPatientCount = useAppSelector((x) => x.configuration.Data?.Config_General.filter((x) => x.Cgn_Nombre === 'ColumnsPatientCount')[0])?.Cgn_Resultado;
  const { isLarge, isMedium } = useScreenSize();
  const dateFormat = useAppSelector((x) => x.configuration.Data?.Config_General.filter((x) => x.Cgn_Nombre === 'DateTimeClientFormat')[0].Cgn_Resultado);
  const cmb = useAppSelector((x) => x.configuration.Data?.ComboBox);
  const info = useAppSelector((x) => x.configuration.Data?.SystemFields)
    ?.filter((x) => x.Dfc_Tabla === 'Pacientes' && x.Dfc_Estado === true)
    .sort((a, b) => a.Dfc_Orden - b.Dfc_Orden);

  const renderItemPatient = (data, field) => {
    let textRender;
    if (PatientData) {
      if (data.Dfc_Dinamico && PatientData.AditionalFields) {
        textRender = PatientData.AditionalFields[field];
      } else {
        textRender = PatientData[field];
      }
    }
    if (data.TipoCampo.Tcm_Equivalencia === 'dxDateBox' && textRender) {
      textRender = moment(textRender).format(dateFormat?.toUpperCase());
    }
    if ((data.TipoCampo.Tcm_Equivalencia === 'dxSwitch' || data.TipoCampo.Tcm_Equivalencia === 'dxCheckBox') && textRender) {
      textRender = textRender === 'true' ? 'SI' : 'NO';
    }
    if (data.TipoCampo.Tcm_Equivalencia === 'dxSelectBox' && textRender) {
      const cmbActual = cmb?.filter((x) => x.Name === data.TablasComboBox.Tbc_NombreTabla)[0];
      const combo = cmbActual?.Data;
      if (combo?.length && combo.length > 0) {
        textRender = combo.filter((x) => x[data.TablasComboBox.Tbc_CampoId] === parseInt(textRender))[0][data.TablasComboBox.Tbc_CampoVisible];
      }
    }

    let maxLength: number;
    switch (ColumnsPatientCount ? parseInt(ColumnsPatientCount) : 1) {
      case 1:
        maxLength = 23;
        break;
      case 2:
        maxLength = 46;
        break;
      case 3:
        maxLength = 69;
        break;
      case 4:
        maxLength = 92;
        break;
      default:
        maxLength = 23;
        break;
    }

    const shortenedString = textRender?.length > maxLength ? textRender.substring(0, 20) + '...' : textRender;
    return (
      <div key={`item${data.Dfc_Id}`} className={`colOrd numcol-${data.Dfc_NroColumnas}`}>
        <div className='label-center'>{data.Dfc_Label}</div>
        <div className='label-content'>{shortenedString ? shortenedString : '---'}</div>
      </div>
    );
  };
  return (
    <div className='profile-card'>
      <div className='profile-card-panel' style={{ height: '180px' }}>
        <div className='profile-card-panel-header'>
          <Toolbar>
            <ItemToolBar location='before' visible={isLarge || isMedium}>
              <span className='title-text'>{formatMessage('OrdPanelPatient')}</span>
            </ItemToolBar>
            <ItemToolBar widget='dxButton' location='after' visible={PatientData && PatientData.Pc_Id ? true : false} showText='inMenu' locateInMenu='auto'>
              <Button id='ViewDataPatient' text={'Ver datos'} stylingMode='outlined' icon={viewPatient} type='default' onClick={handleClickViewPatient} />
            </ItemToolBar>
            <Tooltip showEvent='mouseenter' hideEvent='mouseleave' position={'top'} target={'#ViewDataPatient'}>
              Visualizar paciente
            </Tooltip>
          </Toolbar>
        </div>

        <ScrollView height={'140px'}>
          <div className={`form-container col-container totalColumnCount-${ColumnsPatientCount}`} style={{ height: '90px' }}>
            <div key={`itemID`} className={`colOrd numcol-1`}>
              <div className='label-center'>{formatMessage('PatientField')}</div>
              <div className='label-content'>{PatientData?.Pc_Identificacion ? PatientData?.Pc_Identificacion : '---'}</div>
            </div>
            {info
              ?.filter((x) => x.Dfc_Visible)
              .map((x) => {
                return renderItemPatient(x, x.Dfc_Equivalencia);
              })}
            {/* {info
              ?.filter((x) => x.Dfc_Dinamico && x.Dfc_Visible)
              .map((x) => {
                return renderItemPatient(x, x.Dfc_Equivalencia);
              })} */}
          </div>
        </ScrollView>
      </div>
    </div>
  );
};
